async function cameraPhotoToFile(photo, namePrefix, fetchImpl, now) {
  const sourceUrl = photo?.webPath || photo?.dataUrl;
  if (!sourceUrl) throw new Error('No usable image returned from camera plugin');
  const response = await fetchImpl(sourceUrl);
  const blob = await response.blob();
  const extension = photo.format || (blob.type?.includes('/') ? blob.type.split('/')[1] : 'jpg');
  return new File([blob], `${namePrefix}-${now()}.${extension}`, {
    type: blob.type || `image/${extension}`,
  });
}

export async function pickNativePhotoFiles(source, maxCount, options = {}) {
  const capacitor = options.capacitor === undefined
    ? (typeof window !== 'undefined' ? window.Capacitor : null)
    : options.capacitor;
  const fetchImpl = options.fetchImpl || fetch;
  const now = options.now || Date.now;
  const camera = capacitor?.Plugins?.Camera;

  if (!capacitor?.isNativePlatform?.() || !camera?.getPhoto || maxCount <= 0) return null;

  try {
    if (source === 'PHOTOS' && typeof camera.pickImages === 'function') {
      const result = await camera.pickImages({ quality: 90, correctOrientation: true });
      const selected = (result?.photos || []).slice(0, maxCount);
      return Promise.all(selected.map((photo, index) => (
        cameraPhotoToFile(photo, `photo-${index + 1}`, fetchImpl, now)
      )));
    }

    const photo = await camera.getPhoto({
      source,
      resultType: 'uri',
      quality: 90,
      allowEditing: false,
      saveToGallery: false,
      correctOrientation: true,
    });
    if (!photo) return [];
    return [await cameraPhotoToFile(photo, source === 'CAMERA' ? 'camera' : 'photo', fetchImpl, now)];
  } catch (error) {
    if (/cancel/i.test(String(error?.message || ''))) return [];
    return null;
  }
}
